import { render, staticRenderFns } from "./SearchFilterSelector.vue?vue&type=template&id=5112e7fe&scoped=true&"
import script from "./SearchFilterSelector.vue?vue&type=script&lang=js&"
export * from "./SearchFilterSelector.vue?vue&type=script&lang=js&"
import style0 from "./SearchFilterSelector.vue?vue&type=style&index=0&id=5112e7fe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5112e7fe",
  null
  
)

/* custom blocks */
import block0 from "./SearchFilterSelector.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

/* hot reload */
if (module.hot) {
  var api = require("/builds/RXxibax4-/0/opiniooon/opnn-analytics/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5112e7fe')) {
      api.createRecord('5112e7fe', component.options)
    } else {
      api.reload('5112e7fe', component.options)
    }
    module.hot.accept("./SearchFilterSelector.vue?vue&type=template&id=5112e7fe&scoped=true&", function () {
      api.rerender('5112e7fe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/shared/saved-search-filter/SearchFilterSelector.vue"
export default component.exports